import { caseTime } from "./case-api";
/** 复用既有 Asia/Shanghai 格式函数；共享件统一中文年月日。 */
export function qyTime(value?: string | Date | null): string {
  if (value == null || value === "") return "未记";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "未记";
  const parts = caseTime(date.toISOString()).match(/\d+/g);
  if (!parts || parts.length < 5) return "未记";
  const [year, month, day, hour, minute] = parts;
  return `${year}年${Number(month)}月${Number(day)}日 ${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
}
